import { FC } from 'react'
import { Route, Routes } from 'react-router-dom'
import { UsContracts } from './List/UsContractList'
import UsContractsRoutes from './routes'

const UsContractsPage: FC = () => {
  return (
    <Routes>
      <Route index element={<UsContracts />} />
      <Route path={UsContractsRoutes.relativeListWithTabAndSelected} element={<UsContracts />} />
    </Routes>
  )
}

export default UsContractsPage
